
export default class CluarCustomData {
    constructor(data) {
        this.data = data;
    }
}
